/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pano_drone': {
    width: 16,
    height: 16,
    viewBox: '0 0 234.66 212.35',
    data: '<path pid="0" d="M202.66 100.43v23.92c6.93 4.51 10.66 9.21 10.66 13.32 0 10.48-24.15 24.75-64 30v21.41c45.45-5.63 85.33-23.24 85.33-51.38.01-15.89-12.76-28.35-31.99-37.27zM96 148.35v20.46c-46.19-3.86-74.67-19.73-74.67-31.13 0-4.11 3.74-8.81 10.67-13.32v-23.93c-19.23 8.92-32 21.38-32 37.25 0 30.33 46.31 48.42 96 52.48v22.19l32-32z"/><path pid="1" d="M217.21 68.99A16.88 16.88 0 0 0 200.6 52.6l-51.25 1.16L111.75 0 81.64 2.46l35 51.26 1.79.74-44.4 1-26.32-28-30.27 3.89 48.7 56.62 40.39-1.45-48.91 51.07 33.68-2.81 59.52-47.55 49.82-.92a16.89 16.89 0 0 0 16.57-17.32z"/>'
  }
})
